import React, { FC, useCallback } from 'react';
import { CalendarProvider } from '@wix/ai-scheduling-assistant-common-lib/commonTypes';
import { UOU_CHAT_APP_BASE_URL } from '@wix/ai-scheduling-assistant-constants';
import { useSyncCalendarPopup } from '@wix/ai-scheduling-assistant-view-react';
import { Box, Divider } from '@wix/design-system';
import { useAuthTokenContext } from '../../../context/AuthTokenContext';
import { useCalendarProviderData } from '../../../hooks/useCalendarProviderData';
import { ConnectCalendarModalSection } from './ConnectCalendarModalSection';

export interface ConnectCalendarModalContentProps {
  onAuthSuccess?: () => void;
  onAuthFailure?: () => void;
}

export const ConnectCalendarModalContent: FC<ConnectCalendarModalContentProps> = ({ onAuthSuccess, onAuthFailure }) => {
  const { authToken } = useAuthTokenContext();
  const { calendarProviderData } = useCalendarProviderData();

  const getCalendarOAuthUrl = useCallback(
    async ({ provider }: { provider: CalendarProvider }) => {
      const url = new URL(`${UOU_CHAT_APP_BASE_URL}/connect`);
      const searchParams = url.searchParams;

      searchParams.append('provider', provider);

      if (authToken) {
        searchParams.append('authToken', authToken);
      }

      return url.toString();
    },
    [authToken],
  );

  const { onChooseProvider } = useSyncCalendarPopup({ getCalendarOAuthUrl, onAuthSuccess, onAuthFailure });

  const providerNames = Object.keys(calendarProviderData) as CalendarProvider[];
  return (
    <Box direction="vertical" gap="20px">
      {providerNames
        .filter((providerName) => providerName !== CalendarProvider.ICLOUD)
        .map((providerName, i) => (
          <>
            <ConnectCalendarModalSection
              key={providerName}
              cardData={calendarProviderData[providerName]}
              onChooseProvider={() => onChooseProvider(providerName)}
            />
            {i < providerNames.length - 1 && <Divider direction="horizontal" />}
          </>
        ))}
    </Box>
  );
};
